import React, { Component } from "react";
import { string, bool } from "prop-types";

import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import { Link } from "react-router-dom";

class Logo extends Component {
    static propTypes = {
        className: string,
        inverse: bool,
        link: bool,
    };

    static defaultProps = {
        className: "",
        inverse: false,
        link: false,
    };

    getLogo = () => {
        const { className, inverse } = this.props;
        return (
            <>
                {inverse ? (
                    <Image
                        wrapperClassName="svg-wrapper"
                        src="images/figma/illustrations/logo-white.svg"
                        className={className}
                    />
                ) : (
                    <Image src="images/logoCompany.svg" className={className} />
                )}
                <I18n id="global.companyName" componentProps={{ className: "visually-hidden" }} />
            </>
        );
    };

    render() {
        const { link } = this.props;

        return link ? <Link to="/">{this.getLogo()}</Link> : this.getLogo();
    }
}

export default Logo;
